import { useRef, useState } from "react";
import { Slider } from './Slider';
import { IoLocationSharp } from "react-icons/io5";
import { FaLink, FaRegHeart } from "react-icons/fa6";
import { Projects } from "./Projects";
import { About } from "./About";
import { Skills } from "./Skills";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css';

export function Tabs({ profile, posts, projects, skills }) {
    const [activeTab, setActiveTab] = useState(0);
    const swiperRef = useRef(null);

    const selectedTab = value => {
        setActiveTab(value);
        swiperRef.current.swiper.slideTo(value);
    }


    return (
        <section className="tabs">
            <ul className="tabs__container ps-0 d-flex justify-content-between">
                <li className={`tabs__item p-2 px-2 px-sm-3 text-center d-flex align-items-center ${activeTab === 0 ? 'tabs__item--active' : ''}`} onClick={() => selectedTab(0)}>
                    Feed
                </li>
                <li className={`tabs__item p-2 px-2 px-sm-3 text-center d-flex align-items-center ${activeTab === 1 ? 'tabs__item--active' : ''}`} onClick={() => selectedTab(1)}>
                    Projects
                </li>
                <li className={`tabs__item p-2 px-2 px-sm-3 text-center d-flex align-items-center ${activeTab === 2 ? 'tabs__item--active' : ''}`} onClick={() => selectedTab(2)}>
                    Skills
                </li>
                <li className={`tabs__item p-2 px-2 px-sm-3 text-center d-flex align-items-center ${activeTab === 3 ? 'tabs__item--active' : ''}`} onClick={() => selectedTab(3)}>
                    About
                </li>
            </ul>

            <div className="tabs-content">
                <Swiper
                    ref={swiperRef}
                    spaceBetween={20}
                    slidesPerView={1}
                    autoHeight={true}
                    onSlideChange={(swiper) => setActiveTab(swiper.activeIndex)}
                >
                    <div className={'tabs-content__projects'}>
                        <SwiperSlide
                            className="w-100"
                        >
                            {
                                posts.sort((a, b) => b.orderPost - a.orderPost).map((post, index) => (
                                    <Card
                                        key={index}
                                        imageProfile={profile.imageProfile}
                                        name={profile.name}
                                        post={post}
                                    />
                                ))
                            }
                        </SwiperSlide>
                        <SwiperSlide>
                            <Projects
                                projects={projects} />
                        </SwiperSlide>
                        <SwiperSlide>
                            {
                                skills.map((item, index) => (
                                    <Skills
                                        key={index}
                                        dataSkills={item} />
                                ))
                            }
                        </SwiperSlide>
                        <SwiperSlide>
                            <About
                                profile={profile} />
                        </SwiperSlide>
                    </div>
                </Swiper>
            </div>
        </section>
    );
}

export function Card({ imageProfile, name, post }) {
    return (
        <div className="card pt-4 mb-4">
            <div className="card__body d-flex">
                <div className="card__image-profile">
                    <img className="card__img-profile rounded-circle" src={imageProfile} alt="Imagen de Fernando" />
                </div>
                <div className="card__text ms-2">
                    <div className="card__text-info-profile d-flex mb-1">
                        <p className="card__name-profile mb-0">{name} 🌟</p>
                        <ul className="card__features mb-0 mt-1 mt-lg-0 d-flex">
                            <li className="card__features-item">{post.date}</li>
                        </ul>
                    </div>
                    <div className="card__label">
                        <div className="card__label-body d-inline-flex align-items-center py-1 px-4 rounded-pill">
                            {post.iconLabel}
                            <p className="card__label-body__text mb-0 ms-1">{post.textLabel}</p>
                        </div>
                    </div>
                    <div className="card__text-content">
                        <p className="card__text-content__title mb-1">{post.titlePost}</p>
                        <p className="card__text-content__description">{post.descriptionPost}</p>
                        <div className="card__text-content__slider">
                            <Slider
                                images={post.imagesPost.sort()}
                                descriptionImages='Imagen de Post' />
                        </div>
                        <span className="card__text-content__location mb-0">
                            <IoLocationSharp className="me-1" />
                            {post.locationImagesPost}
                        </span>
                    </div>
                    <div className="card__share d-flex justify-content-end">
                        <span className="card__share-link">
                            <a className="card__share-link__item d-flex align-items-center header__link--disabled" href="www.google.com" target="_blank">
                                <FaLink />
                            </a>
                        </span>
                        <span className="card__share-link d-flex align-items-center">
                            <a className="card__share-link__item d-flex align-items-center header__link--disabled" href="www.google.com" target="_blank">
                                <FaRegHeart />
                            </a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}